export const verfiySSOToken = (data: { [key: string]: any }) => {
  return {
    method: "POST",
    url: `${process.env.REACT_APP_AUTH_URL}/v1/verify-sso-token-for-trainer`,
    data,
  };
};

export const refreshToken = (refreshToken: string) => {
  return {
    method: "GET",
    url: `/api/refresh-token?type=TRAINER`,
    headers: {
      "Content-Type": "application/json",
      "refresh-token": refreshToken,
    },
  };
};
